import type { InteractionsListProps } from "../../types/interactionsList";
import InteractionsListItem from "./InteractionsListItem";

const InteractionsList = (props: InteractionsListProps) => {
  const { interactions, onRemove } = props;

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">
        Interactions{" "}
        {interactions.length > 0 && (
          <span className="text-muted-foreground">({interactions.length})</span>
        )}
      </p>

      {interactions.length === 0 ? (
        <p className="text-sm text-muted-foreground py-2">
          Add at least one interaction to run the analysis.
        </p>
      ) : (
        <ul className="space-y-2">
          {interactions.map((interaction) => {
            return (
              <InteractionsListItem
                key={interaction.id}
                interaction={interaction}
                onRemove={() => onRemove(interaction.id)}
              />
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default InteractionsList;
